import { render, staticRenderFns } from "./markNotDirectlySelect.vue?vue&type=template&id=5a273c49&scoped=true"
import script from "./markNotDirectlySelect.vue?vue&type=script&lang=js"
export * from "./markNotDirectlySelect.vue?vue&type=script&lang=js"
import style0 from "./markNotDirectlySelect.vue?vue&type=style&index=0&id=5a273c49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a273c49",
  null
  
)

export default component.exports